'use strict';

export default class GrpAtrTypeListCtrl {
  constructor($stateParams, $location, LoaderSvc, GrpAtrTypeSvc, GroupAuthSvc) {
    LoaderSvc.start('Loading Group Attributes...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = Number(groupId); // convert to number for disable link check

    // authorization
    GroupAuthSvc.validatePermission(this.groupId, 'groupAttributeType', 'I');

    // default filter
    if(Object.keys($location.search()).length === 0) {
      $location.search({isActive: 'true'}); // string required for url
    }

    that.dataModel = 'gavm';
    GrpAtrTypeSvc.getDefinedBy({groupId}).$promise
      .then(function(data) {
        that.data = data;
        that.order = 'name';
        that.searchField = 'name';
        LoaderSvc.stop();
      })
      .catch(function() {
        LoaderSvc.stopError('Error loading Group Attributes');
      });
  }
}

GrpAtrTypeListCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'GrpAtrTypeSvc',
  'GroupAuthSvc'
];
